import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { IoMdAdd, IoMdCheckmark } from 'react-icons/io';
import { IoClose, IoCreate } from 'react-icons/io5';
import { toast } from 'react-toastify';

function PlanForm({ planData, setPlanData }) {

  const [index, setIndex] = useState(null);
  const [data, setData] = useState({
    serialNumber: '',
    name: '',
  });
  const [inputError, setInputError] = useState(null);

  function handleChange(e) {
    const { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  function handleData() {
    if (data && !data.name) {
      setInputError({ ...inputError, name: 'This field is required.' });
    } else {
      var tempData = planData ? planData : [];
      var serialNumber = tempData.length + 1;
      tempData.push({ ...data, serialNumber: serialNumber });
      setData({ serialNumber: '', name: '' });
      setPlanData(tempData);
    }
  }

  function handleDeleteData(index) {
    let tempData = [...planData];
    tempData.splice(index, 1);
    setPlanData(tempData);
    setData({ serialNumber: '', name: '' });
    setIndex(null);
  }

  return (
    <div id="content" style={{ maxHeight: 360, overflow: 'hidden', overflowY: 'scroll' }}>
      {
        planData && planData.map((item, index) => {
          return (
            <div key={index} className='row m-4 border border-primary-light rounded p-3'>
              <div className='col-md-1 d-flex align-items-center'>
                <div className='d-flex align-items-center'>
                  <h5 className='mb-0'>#{index + 1}</h5>
                </div>
              </div>
              <div className='col-md-9 d-flex align-items-center'>
                <div className='d-flex align-items-center'>
                  <h5 className='mb-0'>{item.name}</h5>
                </div>
              </div>
              <div className='col-md-2 d-flex align-items-center'>
                <div className='d-flex align-items-center'>
                  <Button
                    variant='light'
                    className='p-2 mx-2 rounded-circle'
                  >
                    <IoCreate size={20} color='var(--bs-primary)' />
                  </Button>
                  <Button
                    variant='light'
                    className='p-2 mx-2 rounded-circle'
                    onClick={() => handleDeleteData(index)}
                  >
                    <IoClose size={20} color='var(--bs-danger)' />
                  </Button>
                </div>
              </div>
            </div>
          )
        })
      }
      <div className='row bg-light p-4 border-top'>
        <div className='col-md-12 col-12'>
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>Name of Plan *</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                type="text"
                placeholder="e.g - Plan A, Plan B etc..."
                className={inputError && inputError.name ? 'border-danger' : null}
                onChange={handleChange}
                value={data && data.name}
                isInvalid={inputError && inputError.name}
              />
              {
                data && index !== null ?
                  <Button
                    variant='warning'
                    onClick={handleData}
                    className=''
                  >
                    <IoMdCheckmark size={20} />
                    <span className='ms-1'>Update</span>
                  </Button>
                  :
                  <Button
                    variant='success'
                    onClick={handleData}
                    className='ms-3 btn-width'
                  >
                    <IoMdAdd size={18} />
                    <span className='ms-1'>Add</span>
                  </Button>
              }
              <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        </div>
      </div>
    </div>
  );
}

export default PlanForm;
